export const FIND_DETAIL = '/api/cms/marketing/page/find_detail.json'; // 页面详情
export const BATCH_NOS = 'api/ows/market/coupon/query_by_batch_nos.json'; // 优惠券批次号批量查询
export const HOTEL_LIST = 'api/hotel/batch_search.json'; // 酒店列表
export const SPU_LIST = 'api/mall/product/query/list/spu_ids.json'; // 列表
export const SEND_SMS_CODE = 'sys/sms-code.json'; // 发送验证码
export const USER_LOGIN = 'api/hotel/user/login.json'; // 登录
export const NEW_USER_LOGIN = 'ops/login.json'; // 新用户登录
export const BUILD_URL = 'api/wallet/build_url.json'; //
export const WECHAT_SIGNATURE = 'api/gateway/wechat/signature.json'; // 分享
export const WECHAT_SHARE = 'api/hotel/user/member/wechat/share.json'; // 分享调用的接口
export const RECEIVE_ACTIVITY_COUPON = 'ops/coupon/receive_by_activity_batch.json'; // 领取优惠券
export const GET_LOGIN_USER = 'api/hotel/user/get_login_user.json'; // 用户信息

export const LOTTERY_STATUS = 'ops/lottery/lottery_status.json'; // 抽奖状态，剩余次数等
export const LOTTERY_RECORD = 'ops/lottery/lottery_record.json'; // 抽奖记录
export const LOTTERY = 'ops/lottery/lottery.json'; // 抽奖
export const EXCHANGE = 'api/hotel/user/redeemCode/exchange.json'; // 兑换码
export const GET_MEMBER = 'ops/member/popularize.json'; // 领会员




// WEBPACK FOOTER //
// ./src/common/apiPath.js